<template>
  <div id="ooowin" class="w_bg">
    <new-header></new-header>
    <div class="main_cont_width margin_center main_banner padding_bottom_80">
      <slider
        @tap="onTap"
        v-if="index_banner.length > 0"
        :pages="index_banner"
        :sliderinit="index_slider"
        class="slider index-slider"
      >
        <div slot="loading">loading....</div>
      </slider>
    </div>
    <div class="course-section main_cont_width margin_center mt20">
      <div class="title">
        <p>在线课程</p>
        <p>Online Courses</p>
      </div>
      <div class="course-module">
        <p class="row1">
          <a href="/index_courses.html" target="_blank">
            <img src="./images/course-show1.png" alt="" />
          </a>
          <a href="/ai.html" target="_blank">
            <img src="./images/course-show2.png" alt="" />
          </a>
        </p>
        <p class="row2">
          <a href="/ai_agriculture.html" target="_blank">
            <img src="./images/course-show3.png" alt="" />
          </a>
          <a href="/youerkexue.html" target="_blank">
            <img src="./images/course-show4.png" alt="" />
          </a>
        </p>
      </div>
    </div>
    <div class="news-list main_cont_width margin_center">
      <div class="title">
        <p>专栏资讯</p>
        <p>News</p>
      </div>
      <a class="go-more" href="./index_news.html">更多资讯</a>
      <ul class="clearfix top-img margin_bottom_60">
        <li
          v-for="(item, index) in newsList.topImg"
          class="img_width_100"
          :key="index"
        >
          <a :href="'./news_desc.html?id=' + item.newsId">
            <img :src="item.coverUrl" />
            <div class="black_opacity_bg">
              <p class="nowrap">{{ item.title }}</p>
            </div>
          </a>
        </li>
      </ul>
      <ul class="list-font">
        <li>
          <ul>
            <li v-for="(item, index) in newsList.leftTop" :key="index">
              <a :href="'./news_desc.html?id=' + item.newsId">
                <span></span>
                <p v-if="index === 0 && item.titlePre">
                  {{ item.titlePre }}<i></i
                  >{{
                    item.titlePre.length + item.title.length > 35
                      ? item.title.substring(0, 35 - item.titlePre.length) +
                        "......"
                      : item.title
                  }}
                </p>
                <p :class="{ nowrap: index !== 0 }" v-else>
                  {{
                    item.title.length > 35
                      ? item.title.substring(0, 35) + "......"
                      : item.title
                  }}
                </p>
              </a>
            </li>
          </ul>
          <ul>
            <li v-for="(item, index) in newsList.rightTop" :key="index">
              <a :href="'./news_desc.html?id=' + item.newsId">
                <span></span>
                <p v-if="index === 0 && item.titlePre">
                  {{ item.titlePre }}<i></i
                  >{{
                    item.titlePre.length + item.title.length > 35
                      ? item.title.substring(0, 35 - item.titlePre.length) +
                        "......"
                      : item.title
                  }}
                </p>
                <p :class="{ nowrap: index !== 0 }" v-else>
                  {{
                    item.title.length > 35
                      ? item.title.substring(0, 35) + "......"
                      : item.title
                  }}
                </p>
              </a>
            </li>
          </ul>
        </li>
        <li>
          <ul>
            <li v-for="(item, index) in newsList.leftBot" :key="index">
              <a :href="'./news_desc.html?id=' + item.newsId">
                <span></span>
                <p v-if="index === 0 && item.titlePre">
                  {{ item.titlePre }}<i></i
                  >{{
                    item.titlePre.length + item.title.length > 35
                      ? item.title.substring(0, 35 - item.titlePre.length) +
                        "......"
                      : item.title
                  }}
                </p>
                <p :class="{ nowrap: index !== 0 }" v-else>
                  {{
                    item.title.length > 35
                      ? item.title.substring(0, 35) + "......"
                      : item.title
                  }}
                </p>
              </a>
            </li>
          </ul>
          <ul>
            <li v-for="(item, index) in newsList.rightBot" :key="index">
              <a :href="'./news_desc.html?id=' + item.newsId">
                <span></span>
                <p v-if="index === 0 && item.titlePre">
                  {{ item.titlePre }}<i></i
                  >{{
                    item.titlePre.length + item.title.length > 35
                      ? item.title.substring(0, 35 - item.titlePre.length) +
                        "......"
                      : item.title
                  }}
                </p>
                <p :class="{ nowrap: index !== 0 }" v-else>
                  {{
                    item.title.length > 35
                      ? item.title.substring(0, 35) + "......"
                      : item.title
                  }}
                </p>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="about-us">
      <div class="icon hide">
        <img src="../../assets/images/index/aboutus.png" />
      </div>
      <div class="main_cont_width margin_center">
        <div class="bg">
          <img src="../../assets/images/index/index_about_bg.png" />
        </div>
        <div class="cont">
          <div class="">
            <div class="title">
              <p>关于我们</p>
              <p style="position: relative;top:-4px">About Us</p>
            </div>
            <p style="position: relative;top:-11px">{{ aboutusText }}</p>
          </div>
          <div class="margin_center" style="width: 800px;">
            <slider
              @tap="onTapAboutus"
              v-if="about_banner.length > 0"
              :pages="about_banner"
              :sliderinit="about_slider"
              class="slider left-text about_banner_slider"
            >
              <div slot="loading">loading...</div>
            </slider>
          </div>
        </div>
      </div>
    </div>
    <div class="introduce">
      <div class="title  main_cont_width margin_center">
        <p>{{ companyIdeaInfo.title }}</p>
        <p style="position: relative;top:-4px">
          {{ companyIdeaInfo.subheading }}
        </p>
        <p>{{ companyIdeaInfo.introduce }}</p>
      </div>
      <ul class="main_cont_width margin_center clearfix">
        <li>
          <div class="bg"></div>
          <div class="cont">
            <div class="img-box">
              <img :src="companyIdeaInfo.oneUrl" />
            </div>
            <div class="cont-title">
              <p>{{ companyIdeaInfo.oneIdea }}</p>
            </div>
            <p class="desc">{{ companyIdeaInfo.oneIntroduce }}</p>
          </div>
        </li>
        <li>
          <div class="bg"></div>
          <div class="cont">
            <div class="img-box">
              <img :src="companyIdeaInfo.twoUrl" />
            </div>
            <div class="cont-title">
              <p>{{ companyIdeaInfo.twoIdea }}</p>
            </div>
            <p class="desc">{{ companyIdeaInfo.twoIntroduce }}</p>
          </div>
        </li>
        <li>
          <div class="bg"></div>
          <div class="cont">
            <div class="img-box">
              <img :src="companyIdeaInfo.threeUrl" />
            </div>
            <div class="cont-title">
              <p>{{ companyIdeaInfo.threeIdea }}</p>
            </div>
            <p class="desc">{{ companyIdeaInfo.threeIntroduce }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="contact_us main_cont_width margin_center">
      <div class="title margin_bottom_40">
        <p>联系我们</p>
        <p style="position: relative;top:-2px">Contact Us</p>
      </div>
      <div class="clearfix cont_box">
        <div class="fl address">
          <p class="title">{{ contactUsInfo.compannyName }}</p>
          <p class="clearfix">
            <span class="fl">地址<i>：</i></span
            ><span class="fl">{{ contactUsInfo.address }}</span>
          </p>
          <p class="clearfix">
            <span class="fl">邮编<i>：</i></span
            ><span class="fl">{{ contactUsInfo.zipCode }}</span>
          </p>
          <p class="clearfix">
            <span class="fl">电话<i>：</i></span
            ><span class="fl">0571-88909745</span>
          </p>
          <p class="clearfix">
            <span class="fl">联系我们<i>：</i></span
            ><span class="fl">{{ contactUsInfo.email }}</span>
          </p>

          <div class="QRcode">
            <!--<img class="qrcode-wexin" src="../../assets/images/index/weixin.png"/>-->
            <img class="qrcode-wexin" :src="contactUsInfo.wechatUrl" />
            <p class="weixin-title">微信公众号</p>
          </div>
        </div>
        <div class="fr feedback">
          <p>
            <span>姓名：</span><input v-model="feedback.userName" type="text" />
          </p>
          <p>
            <span>邮箱：</span><input v-model="feedback.email" type="text" />
          </p>
          <p>
            <span>电话：</span><input v-model="feedback.phone" type="text" />
          </p>
          <p class="no-border" style="margin-bottom:5px;">咨询：</p>
          <p class="no-border">
            <textarea v-model="feedback.contents" rows="4" cols="20"></textarea>
          </p>
          <button class="common-hover-btn" @click="addFeedback">发送</button>
        </div>
      </div>
    </div>
    <Modal v-model="modal" width="600" class="index-modal">
      <p slot="header"></p>
      <div style="text-align:center">
        <p class="title">已发送</p>
        <p class="desc">
          请耐心等待，工作人员会在24小时内与您联系，谢谢您的支持！
        </p>
      </div>
      <div slot="footer"></div>
    </Modal>
    <PageFooter></PageFooter>
  </div>
</template>
<script>
import newHeader from "@components/common/newHeader.vue";
import PageFooter from "@components/common/PageFooter.vue";
import PageCenter from "@components/common/PageCenter.vue";
import slider from "vue-concise-slider"; // 引入slider组件
export default {
  name: "app",
  data() {
    return {
      aboutusText: ``,
      stemforFutherText: "200多所学校正在使用STEM未来计划",
      news_kind: [], //资讯类型
      index_banner: [],
      index_slider: {
        effect: "fade",
      },
      /*  sliderInit: {
            currentPage: 0,//当前页码
            thresholdDistance: 500,//滑动判定距离
            thresholdTime: 1000,//滑动判定时间
            autoplay:3000,//自动滚动[ms]
            loop:true,//循环滚动
            direction:'horizontal',//方向设置，垂直滚动
            infinite:1,//无限滚动前后遍历数
            slidesToScroll:1,//每次滑动项数
        },*/
      about_banner: [],
      about_slider: {},
      show_special: "hot",
      special: {},
      feedback: {
        userName: "",
      },
      newsList: {
        topImg: [],
        leftTop: [],
        rightTop: [],
        leftBot: [],
        rightBot: [],
      },
      modal: false,
      bannerJump: {
        index: [],
        aboutus: [],
      },
      contactUsInfo: {
        compannyName: "",
        address: "",
        zipCode: "",
        phone: "",
        email: "",
        wechatUrl: "https://file.ooowin.com/FhMmrc_i202xmhn8CEyChY9USn2d.png",
      },
      companyIdeaInfo: {},
    };
  },
  mounted: function() {
    this.getBanners(1);
    this.getBanners(2);
    this.getNews();
    this.getContactUs();
    this.getCompanyIdea();
  },
  created: function() {},
  watch: {},
  computed: {},
  methods: {
    getContactUs() {
      this.ajax.get("/web/contactUs/getContactUs", null).then((res) => {
        if (res.code == 1) {
          this.contactUsInfo = res.data || {
            compannyName: "",
            address: "",
            zipCode: "",
            phone: "",
            email: "",
            wechatUrl:
              "https://file.ooowin.com/FhMmrc_i202xmhn8CEyChY9USn2d.png",
          };
        }
      });
    },
    getCompanyIdea() {
      this.ajax.post("/web/companyIdea/getCompanyIdea", {}).then((res) => {
        if (res.code == 1) {
          this.companyIdeaInfo = res.data || {};
        }
      });
    },
    onTap(data) {
      console.log(data);
      let index = data.currentPage;
      let jumpUrl = this.bannerJump.index[index];
      if (jumpUrl != 0) {
        //window.location.href = jumpUrl;
        window.open(jumpUrl);
      }
    },
    onTapAboutus(data) {
      console.log(data);
      let index = data.currentPage;
      let jumpUrl = this.bannerJump.aboutus[index];
      if (jumpUrl != 0) {
        window.location.href = jumpUrl;
      }
    },
    getBanners(type) {
      this.ajax.get(this.aUrl.banner_list, { bannerType: type }).then((res) => {
        let pages = [];
        let sliderInit = {
          currentPage: 0, //当前页码
          thresholdDistance: 500, //滑动判定距离
          //thresholdTime: 1000,//滑动判定时间
          loop: true, //循环滚动
          direction: "horizontal", //方向设置，垂直滚动
          infinite: 1, //无限滚动前后遍历数
          slidesToScroll: 1, //每次滑动项数
        };
        let bannerDtoList = [];
        if (res.data) {
          bannerDtoList = res.data.bannerDtoList || [];
        }
        bannerDtoList.map((item) => {
          let p_html = item.title ? `<p>${item.title}</p>` : "";
          let string = item.jumpUrl
            ? //`<a class="imgbox" href="${item.jumpUrl}" ><img src="${item.picUrl}"/>${p_html}</a>`:
              `<a class="imgbox" href="javascript:;" ><img src="${item.picUrl}"/>${p_html}</a>`
            : `<div class="imgbox"><img src="${item.picUrl}"/>${p_html}</div>`;
          pages.push({
            html: string,
          });
          //sliderInit.jumpUrl = item.jumpUrl ? item.jumpUrl :"";
          if (type == 1) {
            this.bannerJump.index.push(item.jumpUrl ? item.jumpUrl : 0);
          } else {
            this.bannerJump.aboutus.push(item.jumpUrl ? item.jumpUrl : 0);
          }
        });
        if (bannerDtoList.length < 2) {
          sliderInit.autoplay = 0;
          sliderInit.loop = false;
        } else {
          sliderInit.autoplay = 3000;
        }
        if (type === 1) {
          this.index_banner = pages;
          this.index_slider = sliderInit;
        } else {
          this.about_banner = pages;
          this.about_slider = sliderInit;
          // 关于我们
          this.aboutusText = (res.data && res.data.about) || "";
        }
      });
    },

    getNews() {
      this.ajax.get(this.aUrl.get_index_news, {}).then((res) => {
        let data = res.data || [];
        this.newsList.topImg =
          data.length > 2 ? data.slice(0, 3) : data.slice(0);
        this.newsList.leftTop =
          data.length > 6 ? data.slice(3, 7) : data.slice(3);
        this.newsList.rightTop =
          data.length > 10 ? data.slice(7, 11) : data.slice(7);
        this.newsList.leftBot =
          data.length > 14 ? data.slice(11, 15) : data.slice(11);
        this.newsList.rightBot = data.slice(15);
      });
    },
    addFeedback() {
      let content = "";
      let regex = /^1[3|4|5|7|8][0-9]\d{8}$/;
      let regex2 = /^0\d{2,3}-?\d{7,8}$/;
      let email_regex = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!this.feedback.email || !this.feedback.phone) {
        content = "请输入至少输入电话或者邮箱中的一个联系方式 ！";
      }
      if (
        !regex.test(this.feedback.phone) &&
        !regex2.test(this.feedback.phone)
      ) {
        content = "联系电话格式错误，请检查 ！";
      }
      if (!email_regex.test(this.feedback.email)) {
        content = "邮箱格式错误，请检查 ！";
      }
      if (!this.feedback.contents) {
        content = "请输入反馈内容 ！";
      }
      if (this.feedback.contents && this.feedback.contents.length > 200) {
        content = "咨询内容最多输入200个字 ！";
      }
      if (content != "") {
        this.$Modal.warning({
          title: "",
          content: content,
        });
        return;
      }
      
      this.ajax.postObj(this.aUrl.feedback_add, this.feedback).then((res) => {
        this.modal = true;
      });
    },
  },
  components: {
    PageFooter,
    PageCenter,
    newHeader,
    slider,
  },
};
</script>
<style lang="scss">
@import "./index.scss";
.about_banner_slider {
  .slider-item p {
    margin-bottom: 0 !important;
  }
}
.QRcode {
  img.qrcode-wexin {
    position: relative;
    left: -10px;
  }
  p.weixin-title {
    position: relative;
    left: -10px;
  }
}
.font20 {
  font-size: 20px !important;
}
</style>
